module.exports = __webpack_public_path__ + "aa350c8a217d215544be042eaf00429e.png";